export default __webpack_public_path__ + "static/media/osm_logo.85cd0e72.png";